import { assign } from '@atds-legacy/lang';
import { Record } from '@redge-media/fo-js-sdk';
import { bookmark, cover, defaultBookmark } from '@/shared/libs/helpers';

const SpecialProduct = Record.mixin(cover).extend({
  endpoint: 'product/',

  constructor: function SpecialProduct(attrs = {}, opts = {}) {
    Record.call(this, assign(attrs, {
      bookmark: attrs.bookmark || assign({}, defaultBookmark),
    }), opts);

    assign(this, bookmark(this));
  },

  set(key, value, opts = {}) {
    const data = Record.prototype.set.call(this, key, value, opts);
    if (!data.title) {
      data.title = data.name;
    }

    return data;
  },
});

export default SpecialProduct;
